import { ApiCallerT } from 'shared/infrastructure/api/types';

import { createVacationRequestsRepository } from "./repositories/vacationRequests.repository";
import { createVacationRequestsApi } from './api/vacationRequests.api';
import { createApplyRequestsApi } from './api/applyRequests.api';
import { vacationRequestsMapper } from './mappers/vacationRequests.mapper';
import { applyRequestsMapper } from './mappers/applyRequests.mapper';

export const buildVacationRequestsRepository = ({ apiCaller }: {
  apiCaller: ApiCallerT
}) => {
  const vacationRequestsApi = createVacationRequestsApi(apiCaller);
  const applyRequestsApi = createApplyRequestsApi(apiCaller);

  return createVacationRequestsRepository({
    vacationRequestsApi,
    applyRequestsApi,
    vacationRequestsMapper,
    applyRequestsMapper,
  });
};
